import RootRouter from 'src/router/RootRouter';
import validateDevExtremeLicense from './utils/validateDevExtremeLicense';

function App() {
  validateDevExtremeLicense();

  return <RootRouter />;
}

export default App;
